export default __webpack_public_path__ + "static/media/logo.3139f3a8.svg";